import RecyclingMaterialsService from 'src/modules/recyclingMaterials/recyclingMaterialsService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { i18n } from 'src/i18n';
import { navigateTo } from 'src/view/shared/routes/helpers';

const prefix = 'RECYCLINGMATERIALS_FORM';

const recyclingMaterialsFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: recyclingMaterialsFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await RecyclingMaterialsService.find(id);
      }

      dispatch({
        type: recyclingMaterialsFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: recyclingMaterialsFormActions.INIT_ERROR,
      });

      navigateTo('/library/recycling-materials');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: recyclingMaterialsFormActions.CREATE_STARTED,
      });

      await RecyclingMaterialsService.create(values);

      dispatch({
        type: recyclingMaterialsFormActions.CREATE_SUCCESS,
      });

      Message.success(i18n('entities.recyclingMaterials.create.success'));

      navigateTo('/library/recycling-materials');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: recyclingMaterialsFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recyclingMaterialsFormActions.UPDATE_STARTED,
      });

      await RecyclingMaterialsService.update(id, values);

      dispatch({
        type: recyclingMaterialsFormActions.UPDATE_SUCCESS,
      });

      Message.success(i18n('entities.recyclingMaterials.update.success'));

      navigateTo('/library/recycling-materials');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: recyclingMaterialsFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default recyclingMaterialsFormActions;
